window.addEventListener('turbolinks:load' , function() {
  if (document.querySelector('.couples.index')) {
    const form = document.querySelector('form#js-couples-search');
    const selects = document.querySelectorAll('form#js-couples-search select');
    const initAutoSubmit = (select) => {
      select.addEventListener('change', (e) => {
        form.submit();
      })
    }
    selects.forEach(initAutoSubmit);
  }

  if (document.querySelector('.couples.edit')) {
    document.addEventListener('click', function(e) {
      const el = e.target.closest('[data-copy-invite]');
      if (!el) return;
      const text = document.getElementById(el.dataset.copySource).value;
      navigator.clipboard.writeText(text).then(function() {
        el.textContent = el.dataset.copyConfirm;
        setTimeout(function() { el.textContent = el.dataset.copyOriginal; }, 2000);
      });
    });
  }
});
